import { ClientReportList } from "./reportsresponse";


export enum ConstFilterIds{
    defaultFilterId =1000,
    newFilterId =999
  }
export interface Report {
    report_key: string;
    favourite:boolean;
    report_description:string;
    claims:any[];
    disable?:boolean;
    access?:boolean;
    translated_name?:string;
    translated_description?:string;
}

export interface ReportListResponse {
   category: string;
   icon:string;
   reports: Report[]
}

export interface REPORTSTOREINTERFACE{
    report_key:string;
    claims:any[],
    analytics_path_param?:string,
    payload:string,
    default_payload:string,
    default_relative_Date:string | null,
    mandatory_fields:any,
    isCompanyLevel:boolean
}

export interface payload{
    from_date:string;
    to_date:string;
    plan_id:number;
    time_zone:string;
    current_page:number;
    page_size: number;
}

export interface ReportResponse {
    current_page: number;
    items:ClientReportList[] | any[];
    statistics: any[] | any[];
    total_items:number;
    total_pages:number
 }

 export class ReportFormBase<T> {
    value: any | undefined;
    key: string;
    label: string;
    required: boolean;
    order: number;
    controlType: string
    type: string;
    options: { key: string; value: string }[];
    data: any;
  
    constructor(
      options: {
        value?: any;
        key?: string;
        label?: string;
        required?: boolean;
        order?: number;
        controlType?: string;
        type?: string;
        options?: { key: string; value: string }[] | any;
        data?: any;
      } = {}
    ) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.required = !!options.required;
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.type = options.type || '';
      this.options = options.options || [];
    }
  }
  
  export class Dropdown extends ReportFormBase<string> {
    override controlType = 'dropdown';
  }
  
  export class TimePeriodDropdown extends ReportFormBase<string> {
    override controlType = 'timeperioddropdown';
  }
  
  export class Textbox extends ReportFormBase<string> {
    override controlType = 'textbox';
  }
  
  export class HiddenField extends ReportFormBase<string> {
    override controlType = 'hiddenfield';
  }
  
  
  export class MultiSelect extends ReportFormBase<string> {
    override controlType = 'multiselect';
  }
  
  export class InputSwitch extends ReportFormBase<string> {
    override controlType = 'inputswitch';
  }
  
  export class DatePicker extends ReportFormBase<string> {
    override controlType = 'datepicker';
  }
  



